export default "__VITE_ASSET__CDGnC8PS__"